export default __webpack_public_path__ + "static/media/20B4152E-08AC-49E8-B294-92719B03C499.ba39e846.jpg";